import { styled } from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 20px;
`;
export const Label = styled.label`
  font-size: 13px;
  color: #ffffff8f;
`;
